/**
 * The single entry point for a caught error in the browser that would otherwise vanish.
 *
 * A `.catch` that shows a toast tells the user something failed but throws away WHAT failed,
 * and a `catch {}` around browser storage tells nobody. Both go through here so the error
 * object reaches the dev console, where it can be read and expanded.
 *
 * It lives in the UI kit because modules may import only `@noissue/os-ui` and
 * `@noissue/authz`, and `no-console` is an error across packages: this is the one sanctioned
 * console call, so it stays findable. If client errors are later forwarded to Sentry, this is
 * the seam to do it — callers don't change.
 */
export function reportError(
  scope: string,
  error: unknown,
  context?: Record<string, unknown>,
): void {
  // eslint-disable-next-line no-console -- the one sanctioned browser log; see the header.
  console.error(`[${scope}]`, error, ...(context ? [context] : []));
}
